import { Component, TemplateRef, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-marketplace-transactions-paiement',
  standalone: false,
  templateUrl: './marketplace-transactions-paiement.component.html',
  styleUrl: './marketplace-transactions-paiement.component.scss'
}) 


export class MarketplaceTransactionsPaiementComponent {

  items: any = [];
  user_reference: any;
  paginatedItems = [];
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  isLoading: boolean = false;
  searchTerm: string = "";
  filteredtems: any = [];
  searchDate: string = '';
  dateDebut: string = '';
  dateFin: string = '';
  searchGender: string = '';
  isDisabled: boolean = false;
  
  // Ajout du filtre par statut de commande
  selectedStatus: string = '';
  statusOptions: any[] = [
    { label: 'Tous les statuts', value: '' },
    { label: 'Payé', value: 'paid' },
    { label: 'Échoué', value: 'failed' },
    { label: 'En attente', value: 'pending' },
    { label: 'En cours', value: 'processing' }
  ];
  
  // Filtrer par statut de commande (order_status)
  selectedOrderStatus: string = '';
  orderStatusOptions: any[] = [
    { label: 'Tous les statuts', value: '' },
    { label: 'Traité', value: 'traite' },
    { label: 'En attente', value: 'en_attente' },
    { label: 'En cours', value: 'en_cours' },
    { label: 'Annulé', value: 'annule' }
  ];
  
  // Propriétés pour le détail
  selectedItem: any = null;
  showDetailModal: boolean = false;
  
  @ViewChild('modalContent') modalContent!: TemplateRef<any>;
  @ViewChild('detailModal') detailModal!: TemplateRef<any>;

  constructor(
    private modalService: NgbModal,
    private localstorage: LocalStorageService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private ngxService: NgxUiLoaderService,
    private router: RouterModule,
    private FecthDataService: FecthDataService,
    private paramService: ParameterService,
    private authService: AuthService
  ) {
    this.user_reference = this.localstorage.getUsers().data.reference;
    console.log("this.user_reference", this.user_reference);
    this.FecthDataService.actionCreated$.subscribe(() => {
      this.getAllCommandeMarketPlace();
    });
  }

  ngOnInit() {
    this.getAllCommandeMarketPlace();
  }

  // Méthode pour ouvrir le modal de détails
  openDetailModal(item: any) {
    this.selectedItem = item;
    this.modalService.open(this.detailModal, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
      scrollable: true
    });
  }

  // Méthode pour obtenir le badge de statut de paiement
  getStatusBadge(statut: string): string {
    const statusMap: {[key: string]: string} = {
      'paid': 'bg-success',
      'failed': 'bg-danger',
      'pending': 'bg-warning',
      'processing': 'bg-info'
    };
    return statusMap[statut] || 'bg-secondary';
  }

  // Méthode pour obtenir le badge de statut de commande
  getOrderStatusBadge(orderStatus: string): string {
    const statusMap: {[key: string]: string} = {
      'traite': 'bg-success',
      'en_attente': 'bg-warning',
      'en_cours': 'bg-info',
      'annule': 'bg-secondary'
    };
    return statusMap[orderStatus] || 'bg-secondary';
  }

  // Méthode pour obtenir le libellé du statut en français
  getStatusLabel(statut: string): string {
    const statusMap: {[key: string]: string} = {
      'paid': 'Payé',
      'failed': 'Échoué',
      'pending': 'En attente',
      'processing': 'En cours'
    };
    return statusMap[statut] || statut;
  }

  // Méthode pour obtenir le libellé du statut de commande en français
  getOrderStatusLabel(orderStatus: string): string {
    const statusMap: {[key: string]: string} = {
      'traite': 'Traité',
      'en_attente': 'En attente',
      'en_cours': 'En cours',
      'annule': 'Annulé'
    };
    return statusMap[orderStatus] || orderStatus;
  }

  // Méthode pour formater la date
  formatDate(date: string): string {
    if (!date) return '-';
    const d = new Date(date);
    return d.toLocaleString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  getAllCommandeMarketPlace() {
    this.isLoading = true;
    this.authService.getAllCommandeMarketPlace(this.user_reference).subscribe(
      (response: any) => {
        this.isLoading = false;
        this.items = response.data;
        this.filteredtems = this.items;
        this.totalRecords = this.items.length;
        this.applyFilters();
        console.log("la reponse du webservice", this.items);
      },
      (error) => {
        console.log("une erreur est survenue", error);
        this.isLoading = false;
      }
    )
  }

  resetFilters() {
    this.searchTerm = '';
    this.selectedStatus = '';
    this.selectedOrderStatus = '';
    this.dateDebut = '';
    this.dateFin = '';
    this.applyFilters();
  }

  // Méthode pour appliquer tous les filtres
  applyFilters() {
    let filtered = this.items;

    // Filtre par statut de paiement
    if (this.selectedStatus) {
      filtered = filtered.filter(item => item.status === this.selectedStatus);
    }

    // Filtre par statut de commande
    if (this.selectedOrderStatus) {
      filtered = filtered.filter(item => item.order_status === this.selectedOrderStatus);
    }

    // Filtre par date
    if (this.dateDebut) {
      const startDate = new Date(this.dateDebut);
      startDate.setHours(0, 0, 0, 0);
      filtered = filtered.filter(item => {
        const itemDate = new Date(item.created_at);
        return itemDate >= startDate;
      });
    }

    if (this.dateFin) {
      const endDate = new Date(this.dateFin);
      endDate.setHours(23, 59, 59, 999);
      filtered = filtered.filter(item => {
        const itemDate = new Date(item.created_at);
        return itemDate <= endDate;
      });
    }

    // Filtre par recherche
    if (this.searchTerm && this.searchTerm.trim() !== '') {
      const search = this.searchTerm.toLowerCase().trim();
      filtered = filtered.filter(item =>
        (item?.reference && item.reference.toLowerCase().includes(search)) ||
        (item?.ref_marchand && item.ref_marchand.toLowerCase().includes(search)) ||
        (item?.acheteur?.nom && item.acheteur.nom.toLowerCase().includes(search)) ||
        (item?.acheteur?.prenom && item.acheteur.prenom.toLowerCase().includes(search)) ||
        (item?.acheteur?.telephone && item.acheteur.telephone.toLowerCase().includes(search)) ||
        (item?.livraison?.telephone && item.livraison.telephone.toLowerCase().includes(search)) ||
        (item?.status && item.status.toLowerCase().includes(search)) ||
        (item?.order_status && item.order_status.toLowerCase().includes(search)) ||
        (item?.payment_method && item.payment_method.toLowerCase().includes(search)) ||
        (item?.montant_total && item.montant_total.toString().includes(search))
      );
    }

    this.filteredtems = filtered;
    this.totalRecords = this.filteredtems.length;
    this.first = 0;
    this.updatePaginated();
  }

  // Méthode appelée lors du changement de filtre
  onStatusChange() {
    this.applyFilters();
  }

  onOrderStatusChange() {
    this.applyFilters();
  }

  // Méthode appelée lors de la recherche
  filterBySearchTerm() {
    this.applyFilters();
  }

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.updatePaginated();
  }

  updatePaginated() {
    const start = this.first;
    const end = start + this.rows;
    this.paginatedItems = this.filteredtems.slice(start, end);
  }

  getTotalItemsMontant(items: any[]): number {
    if (!items || items.length === 0) return 0;
    return items.reduce((total, item) => total + item.sous_total, 0);
  }

  // Méthode pour compter les transactions par statut
  getStatusCount(status: string): number {
    if (!this.items) return 0;
    if (!status) return this.items.length;
    return this.items.filter(item => item.status === status).length;
  }

  getOrderStatusCount(status: string): number {
    if (!this.items) return 0;
    if (!status) return this.items.length;
    return this.items.filter(item => item.order_status === status).length;
  }

  // Méthode pour obtenir le libellé du mode de paiement
  getPaymentMethodLabel(method: string): string {
    const methodMap: {[key: string]: string} = {
      'mtn': 'MTN Mobile Money',
      'moov': 'Moov Mobile Money',
      'celtiis': 'Celtiis',
      'orange': 'Orange Money'
    };
    return methodMap[method] || method || 'Non spécifié';
  }

  // Méthode pour obtenir une icône du mode de paiement
  getPaymentMethodIcon(method: string): string {
    const iconMap: {[key: string]: string} = {
      'mtn': 'mdi mdi-phone',
      'moov': 'mdi mdi-phone',
      'celtiis': 'mdi mdi-credit-card',
      'orange': 'mdi mdi-phone'
    };
    return iconMap[method] || 'mdi mdi-credit-card';
  }
}